{
  "FormEngineShowPageWfl": {
    "title": "Seite anzeigen",
    "description": "Reagieren Sie auf Ereignisse, indem Sie ein konfiguriertes Seitenelement anzeigen"
  },
  "mask": {
    "FormEngineShowPageWfl": {
      "groupTitle": "Buchseite"
    }
  }
}